// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const B2E_DOMAIN = 'ross-applications.eu-central-1.aws.cloud.bmw';
const B2D_DOMAIN = 'ross-applications.aws.bmw.cloud';
const domain = window.location.hostname;
export const environment = {
  production: true,

  b2e: {
    serverURL:
      'https://ross-applications.eu-central-1.aws.cloud.bmw/api/ross/icd/v1',
    oauthDomainURL: 'https://us.prod.alpha.sso.bmwgroup.com',
    issuer:
      'https://us.prod.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha',
    redirectUri: 'https://ross-applications.eu-central-1.aws.cloud.bmw',
    clientId: 'bf3bce49-3131-4507-9751-7146d71a8f8c',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles',
    loginUrl:
      'https://us.prod.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: false,
    userType: 'B2E',
    env: 'PROD',
    acr_values: 'strongAuth4000Service',
  },
  b2d: {
    serverURL: 'https://ross-applications.aws.bmw.cloud/api/ross/icd/v1',
    oauthDomainURL: 'https://us.prod.alpha.sso.bmwgroup.com',
    issuer:
      'https://us.prod.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha',
    redirectUri: 'https://ross-applications.aws.bmw.cloud',
    clientId: '06af474e-f82d-451b-9e4d-99392333a25b',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles b2d',
    loginUrl:
      'https://us.prod.alpha.sso.bmwgroup.com:443/auth/oauth2/realms/root/realms/alpha/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: false,
    userType: 'B2D',
    env: 'PROD',
    acr_values: 'strongAuth4000Service',
  },

  domain: domain,
  domainType: domain.includes(B2E_DOMAIN) ? 'b2e' : 'b2d',
  isB2D: domain.includes(B2D_DOMAIN),
  isB2E: domain.includes(B2E_DOMAIN),
};

// console.log('current environment ', environment);
